import React from "react";
import "./Profile.css";

function Profile(){
    return <div className="profile">Profile</div>;
}

export default Profile;